export default "__VITE_ASSET__qELxV0pT__"